import * as API from '@/utils/request';

export default {
	verifyUrl: () => API.GET('/adm_arena/v4/sessions/actions/verify_token'),
};
